function filterLinks(index) {
  const input = document.getElementById("searchInputMobile");
  const filter = input.value.toUpperCase();
  const items = document.querySelectorAll(`#linkList${index} .searchable-item`);
  const noResultsMessage = document.getElementById("noResultsMessage");
  
  let found = false;

  items.forEach(item => {
    const txtValue = item.dataset.title || item.innerText;
    if (txtValue.toUpperCase().includes(filter)) {
      item.style.display = "";
      found = true;
    } else {
      item.style.display = "none";
    }
  });

  if (noResultsMessage) {
    noResultsMessage.style.display = found ? "none" : "block";
  }
}

function clearSearchMobile(index) {
  const input = document.getElementById("searchInputMobile");
  input.value = '';
  filterLinks(index); // Reset the filter to show all items
  toggleClearButtonMobile();
  resetPlaceholder();
}

function toggleClearButtonMobile() {
  const searchInput = document.getElementById("searchInputMobile");
  const clearButton = document.querySelector('.clear-button-mobile');
  clearButton.style.display = searchInput.value.length > 0 ? 'flex' : 'none';
}

function resetPlaceholder() {
  const placeholder = document.querySelector('.placeholder-drawer');
  placeholder.classList.toggle('has-content', !!document.getElementById("searchInputMobile").value);
}

document.addEventListener("DOMContentLoaded", () => {
  const inputs = document.querySelectorAll('.menu-drawer__search-input');
  const placeholders = document.querySelectorAll('.placeholder-drawer');

  inputs.forEach((input, index) => {
    const updatePlaceholder = () => {
      placeholders[index].classList.toggle('has-content', input.value.trim() !== '');
    };

    input.addEventListener('input', () => {
      updatePlaceholder();
      toggleClearButtonMobile();
    });
    input.addEventListener('blur', updatePlaceholder);
  });
});